import React, { useState } from "react";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Tooltip, IconButton, Typography, Box, Divider } from "@mui/material";

// Utility to format date/time into a more readable form
const formatDateTime = (dateString: string) => {
  if (!dateString) return "-";
  const d = new Date(dateString);
  return d.toLocaleString();
};

export const QuickbookTransactionDetails = ({ totalList, title  }: { totalList: any, title : string }) => {
  const [copied, setCopied] = useState(false);

  // Format payload for nice viewing in the box
  let formattedJson = "";
  try {
    formattedJson = JSON.stringify(JSON.parse(totalList.payload), null, 2);
  } catch {
    formattedJson = totalList.payload;
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(formattedJson);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Box
       
    >  
      <Typography variant="body2" sx={{ mb: 0.5, mt: 0.5 }}>
        <b>Transaction Date:</b> {formatDateTime(totalList.submitTime)}
      </Typography>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        <b>Type:</b> {totalList.type}
      </Typography>
      {totalList.status && <Typography variant="body2" sx={{ mb: 0.5 }}>
        <b>Status:</b> {totalList.status}
      </Typography>}
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        <b>Correlation ID:</b> {totalList.correlationId}
      </Typography>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        <b>User Id:</b> {totalList.createdBy}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 500, mt: 2 }}>
       <b>Payload:</b> 
      </Typography>

      <Box
        sx={{
          position: "relative",
          mt: 1,
          mb: 1,
          border: "1px solid #c2c2c2",
          borderRadius: 1,
          bgcolor: "#f9f9f9",
          minHeight: 120,
          maxHeight: 300,
          overflowY: "auto",
          px: 2,
          pt: 2,
          pb: 1,
        }}
      >
        {/* Copy button - always at top right inside payload box */}
        <Tooltip title={copied ? "Copied!" : "Copy JSON"} arrow>
          <IconButton
            onClick={handleCopy}
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              zIndex: 2,
              color: copied ? "success.main" : "text.secondary",
              bgcolor: copied ? "#e7fce7" : "transparent",
              transition: "color 0.2s, bgcolor 0.2s",
            }}
          >
            {copied ? <CheckCircleIcon fontSize="small" /> : <CopyAllIcon fontSize="small" />}
          </IconButton>
        </Tooltip>

        <pre
          style={{
            margin: 0,
            fontSize: 14,
            fontFamily: "monospace",
            color: "#212121",
            background: "inherit",
            wordBreak: "break-all",
            whiteSpace: "pre-wrap",
          }}
        >
          {formattedJson}
        </pre>
      </Box>
    </Box>
  );
};
